import React from 'react'
import {
  CardOnFileContainer,
  CardOnFileActions,
  CardOnFileBox,
  CardOnFileCVCInput,
  CardOnFileCardBox,
  CardOnFileDescription,
  CardOnFileIcon,
  CardOnFileLabel,
  CardOnFileNumber,
  CardOnFilePrimaryButton,
  CardOnFileSecondaryButton,
  CardOnFileTitle,
} from '../../card-on-file.styled'
import {useBillingInfo} from './contexts/billing-info-context'
import {amexLogo, discoverLogo, mastercardLogo, visaLogo} from '../../../assets'
import {toast} from 'react-toastify'
import {usePaymentCheckboxes} from './contexts/payment-checkboxes-context'
import {useRecurlyPayment} from './contexts/recurly-payment-context'

export function CardOnFileForm({setPaymentRequestState}) {
  const {
    billingInfo,
    verifyCVC,
    isCVCVerified,
    setIsCVCVerified,
    isVerifying,
    setTryCardOnFile,
    cvc,
    setCVC,
  } = useBillingInfo()
  const {checkBoxesValues, setCheckBoxesValues} = usePaymentCheckboxes()
  return (
    <CardOnFileContainer>
      <CardOnFileTitle>Confirm Card On File</CardOnFileTitle>
      <CardOnFileDescription>
        For security, please enter your card&apos;s CVC to continue.
      </CardOnFileDescription>

      <CardOnFileCardBox>
        <div>
          <CardOnFileNumber>
            {billingInfo.paymentMethod.cardType} ending in{' '}
            {billingInfo.paymentMethod.lastFour}
          </CardOnFileNumber>
          <CardOnFileDescription>
            Exp {billingInfo.paymentMethod.expMonth.toString().padStart(2, '0')}
            /{billingInfo.paymentMethod.expYear.toString().slice(2)} ·{' '}
            {billingInfo.firstName} {billingInfo.lastName}
          </CardOnFileDescription>
        </div>

        {billingInfo.paymentMethod.cardType === 'American Express' && (
          <CardOnFileIcon
            src={amexLogo}
            alt={`${billingInfo.paymentMethod.cardType} logo`}
          />
        )}

        {billingInfo.paymentMethod.cardType === 'Visa' && (
          <CardOnFileIcon
            src={visaLogo}
            alt={`${billingInfo.paymentMethod.cardType} logo`}
          />
        )}

        {billingInfo.paymentMethod.cardType === 'MasterCard' && (
          <CardOnFileIcon
            src={mastercardLogo}
            alt={`${billingInfo.paymentMethod.cardType} logo`}
          />
        )}

        {billingInfo.paymentMethod.cardType === 'Discover' && (
          <CardOnFileIcon
            src={discoverLogo}
            alt={`${billingInfo.paymentMethod.cardType} logo`}
          />
        )}
      </CardOnFileCardBox>

      <CardOnFileBox>
        <CardOnFileLabel>CVC</CardOnFileLabel>
        <CardOnFileCVCInput
          placeholder="3 or 4 digits"
          data-dd-privacy="mask"
          type="text"
          name="cvc"
          maxLength={4}
          disabled={checkBoxesValues.agreedTerms}
          onChange={e => {
            setCVC(e.target.value)
            setCheckBoxesValues({
              ...checkBoxesValues,
              agreedTerms: false,
            })
          }}
          value={cvc}
        />
        <CardOnFileDescription>
          Typically 3 digits on the back; 4 on Amex.
        </CardOnFileDescription>
      </CardOnFileBox>

      <CardOnFileActions>
        <CardOnFileSecondaryButton
          disabled={isVerifying || checkBoxesValues.agreedTerms}
          type="button"
          onClick={() => {
            setTryCardOnFile(false)
            setPaymentRequestState({
              hasErrors: false,
              requested: false,
              merchantMessage: null,
            })
            setCheckBoxesValues({
              ...checkBoxesValues,
              agreedTerms: false,
            })
            setIsCVCVerified(false)
          }}
        >
          Use Different Payment
        </CardOnFileSecondaryButton>
        <CardOnFilePrimaryButton
          disabled={
            isVerifying || isCVCVerified || checkBoxesValues.agreedTerms
          }
          type="button"
          onClick={async e => {
            e.preventDefault()
            const {valid, message} = await verifyCVC(cvc)
            if (!valid) {
              toast.error(message)
              return undefined
            }
            toast.success(message)
          }}
        >
          Confirm Card
        </CardOnFilePrimaryButton>
      </CardOnFileActions>
    </CardOnFileContainer>
  )
}

export function ChangeToCardOnFileButton() {
  const {billingInfo, setTryCardOnFile} = useBillingInfo()
  const {checkBoxesValues, setCheckBoxesValues} = usePaymentCheckboxes()
  const {clearRecurlyToken} = useRecurlyPayment()
  if (!billingInfo) return undefined

  return (
    <div className="flex justify-end mt-2">
      <CardOnFileSecondaryButton
        type="button"
        disabled={checkBoxesValues.agreedTerms}
        onClick={() => {
          setTryCardOnFile(true)
          clearRecurlyToken()
          setCheckBoxesValues({
            ...checkBoxesValues,
            agreedTerms: false,
          })
        }}
      >
        Use card on file
      </CardOnFileSecondaryButton>
    </div>
  )
}
